export default __webpack_public_path__ + "static/mobile_KV03-c829bfd80303e452ee7e72c2de6312b6.mp4";